module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block2_Mobile-370db9c2a7f8194e737bff43c715cf27.png";